// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"72":"css/pages/stock-count-manage","213":"css/loading","235":"css/dosage_label","252":"css/app","281":"css/receipt","288":"css/form-layout","481":"css/pricing-page","538":"css/procurement-form"}[chunkId] + ".css";
};